import styled from 'styled-components'
import colors from '../../../tokens/colors'
import fonts from '../../../tokens/fonts'
import typography from '../../../tokens/typography'
import layout from '../../../tokens/layout'
import border from '../../../tokens/border'
import { defaultTheme } from '../../../theming/data/defaultTheme'
import { composeTheme } from '../../../utils/compose-theme'

interface ComponentProps {
  readonly active?: boolean
  readonly notification?: boolean
}

export const Icon = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  background-color: transparent;
  display: flex;
  flex-basis: ${(props) => (props.theme.collapsed ? '4.8rem' : '0.6rem')};
  flex-grow: 0;
  flex-shrink: 0;
  font-size: ${typography.fontSize.fontSizeXxs};
  justify-content: center;
  margin-right: ${layout.margin.spacingNone};
  &.is-disabled {
    > div {
      background-color: ${(props) =>
        props.theme.brandColors?.sideMenuBackgroundColor
          ? props.theme.brandColors.sideMenuBackgroundColor
          : colors.neutralColorHighLight};
      color: ${colors.neutralColorLowMedium};
    }
  }
`

export const Img = styled.div`
  max-height: 2.4rem;

  img {
    height: auto;
    width: 2.4rem;
  }
`

export const Button = styled.button.attrs((props) => composeTheme(props))`
  align-items: center;
  background: transparent;
  border: ${border.width.widthNone};
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  margin: ${layout.margin.spacingNone};
  overflow: visible;
  outline: none;
  padding: ${layout.padding.spacingInsetNone};
  position: relative;
  text-decoration: none;
  width: auto;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }

  &:hover {
    color: ${(props) =>
      props.theme.brandColors
        ? props.theme.brandColors.primaryPure
        : colors.brandColorPrimaryPure};
    transition: color 0.25s;
  }

  &.is-open {
    ${Icon} {
      color: ${(props) =>
        props.theme.brandColors
          ? props.theme.brandColors.primaryPure
          : colors.brandColorPrimaryPure};
    }
  }
`

export const Text = styled.div`
  display: ${(props) => (props.theme.collapsed ? 'none' : 'inline-block')};
  text-align: left;
  &.is-disabled {
    color: ${colors.neutralColorLowMedium};
    cursor: not-allowed;
  }
`

export const Item = styled.div.attrs((props) =>
  composeTheme(props),
)<ComponentProps>`
  color: ${(props) => {
    if (props.active) return composeColorActive(props)
    if (!props.theme.brandColors?.sideMenuFontColor)
      return colors.neutralColorLowPure
    return props.theme.brandColors.sideMenuFontColor
  }};
  transition: color 0.25s;
  border-left: ${border.width.widthThin} solid
    ${(props) => {
      if (props.active) return composeColorActive(props)
      if (!props.theme.brandColors?.sideMenuBackgroundColor)
        return colors.neutralColorHighPure
      return props.theme.brandColors.sideMenuBackgroundColor
    }};
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-weight: ${typography.fontWeight.fontWeightSemiBold};
  margin: ${layout.margin.spacingNano} ${layout.margin.spacingNone};
  padding: ${(props) =>
    props.notification
      ? layout.padding.spacingInsetNone
      : layout.padding.spacingInsetXs};

  ${Icon} {
    color: ${(props) => {
      if (props.active) return composeColorActive(props)
      return 'inherit'
    }};
    margin-right: ${layout.margin.spacingXxxs};
  }
`

export const SubmenuArrow = styled.div.attrs((props) => composeTheme(props))`
  margin-left: auto;

  ${Icon} {
    color: ${(props) =>
      props.theme.brandColors?.sideMenuFontColor
        ? props.theme.brandColors.sideMenuFontColor
        : colors.neutralColorLowPure} !important;
    display: ${(props) => (props.theme.collapsed ? 'none' : 'flex')};
  }
`

export const SubmenuContainer = styled.div`
  display: flex;
  width: ${(props) => (props.theme.collapsed ? '0px' : '180px')};
  justify-content: space-between;
`

export const WrapperNotification = styled.li.attrs((props) =>
  composeTheme(props),
)<ComponentProps>`
  color: ${(props) =>
    props.theme.brandColors
      ? props.theme.brandColors.primaryPure
      : colors.brandColorPrimaryPure};
  font-size: ${typography.fontSize.fontSizeSm};
  width: 1.7rem;
`

Button.defaultProps = defaultTheme
Item.defaultProps = defaultTheme

export function composeColorActive(props) {
  return props.theme.brandColors
    ? props.theme.brandColors.primaryPure
    : colors.brandColorPrimaryPure
}
